import React, { Component, Fragment } from 'react';
import PaymentCreditCard from './PaymentCreditCard';
import PaymentCinecash from './PaymentCinecash';
import PaymentCC from './PaymentCC';
import Input from './Input';
import PriceZero from './PriceZero';


class PaymentMethods extends Component {
  constructor(props) {
    super(props);

    this.paymentTypes = [
      { cssName: 'bizum', img: 'bizum.png', title: 'Bizum', code: 'bizum_tickets' },
      { cssName: 'redsys', img: 'tarjeta.png', title: 'Tarjeta de crédito o débito', code: 'redsys_tickets' },
      { cssName: 'reserve', img: 'ticket-reserva.svg', title: 'Reservación', code: 'unpaid_booking' },
      { cssName: 'cinecash', img: 't-cinecash.png', title: 'Cinecash®', code: 'cinecash' },
      { cssName: 'cc', img: 'tarjeta-cc.svg', title: 'Movie Cine Yelmo®', code: 'loyalty_tickets' },
      { cssName: 'paypal', img: 'paypal.svg', title: 'Paypal', code: 'paypal_tickets' },
      { cssName: 'visa', img: 'visa-checkout.svg', title: 'Visa Checkout', code: 'visa_checkout' }
    ];
  }

  handleActivePayment = (e) => {
    const clickedElem = e.currentTarget;

    if (e.target.tagName === 'BUTTON' && e.target.className === 'btn btn--clean') return;

    this.props.handleActiveForm(clickedElem.dataset.code);
  };

  handleActiveLoyalty = (payment_code) => {
    this.props.handleActiveForm(payment_code);
  }

  componentDidMount() {
    const { isPriceZero} = this.props;
    if(isPriceZero){
      this.handleActiveLoyalty('price-zero');
    }
  }

  render() {
    const { modal, isMobile, active, paymentMethodsSettings, isPriceZero, isAnnualPass, accept_terms, hasFolio} = this.props;
    let containerClassName = '';

    if (!this.props.mobilePaymentMethodsOpen) {
      containerClassName = ' select';
    } else {
      containerClassName = ' selected';
    }

    return (
      <section className="payment__methods">
        {isPriceZero && <PriceZero />}

        {!isPriceZero &&
          <Fragment>
            <h1 className="title">Selecciona el método de pago</h1>

            <ul
              className={`nostyle payment__types-list${containerClassName}`}
              data-selectedmobiletext='Método de pago seleccionado'
            >
              
            {this.paymentTypes.map(type => {

              if (this.props.disabled !== null && this.props.disabled.includes(type.code)) {
                  return null;
                }
              
              if (hasFolio && type.code === 'unpaid_booking')
                return null;
              
              if ((type.code !== 'bizum_tickets' && type.code !== 'redsys_tickets') && !paymentMethodsSettings.includes(type.code)) {
                  return null;
                }

              if (type.code === 'loyalty_tickets' || type.code === 'paypal_tickets') {
                return null;
              }

                return <li
                  className={`payment__types-item payment__types-item--${type.cssName}${active === type.code ? ' active' : ''}`}
                  key={type.title}
                  data-code={type.code}
                  onClick={this.handleActivePayment}
                >
                  <figure className="payment__type-img">
                    <img src={require(`../static/images/icons/${type.img}`)} alt={`Cine Yelmo - ${type.title}`} />
                  </figure>
                  <span className="payment__type-text">{type.title}</span>

                  {isMobile && <button type="button" className="btn btn--clean" onClick={this.props.onChangeMobileMethods}>CAMBIAR</button>}
                </li>;
              })}
            </ul>

            <div className="payment__types">
              <PaymentCreditCard
                active={active === 'bank_card' && (this.props.mobilePaymentMethodsOpen || this.props.mobilePaymentMethodsOpen === null)}
                onInputChange={this.props.onInputChange}
              />
              <PaymentCinecash
                active={active === 'cinecash' && (this.props.mobilePaymentMethodsOpen || this.props.mobilePaymentMethodsOpen === null)}
              />
              <PaymentCC
              active={active === 'loyalty_tickets' && (this.props.mobilePaymentMethodsOpen || this.props.mobilePaymentMethodsOpen === null)}
                onInputChange={this.props.onInputChange}
                modal={modal}
              />
            </div>
          </Fragment>
        }

        <div className="payment__terms">
          <Input
            type="checkbox"
            name="accept_terms"
            id="accept_terms"
            defaultChecked={this.props.accept_terms}
            onChange={this.props.onInputChange}
          >
            He leído y estoy de acuerdo con los <a href={this.props.terms} className="link" target="_blank" rel="noopener noreferrer">Política de privacidad</a> y el&nbsp;
            <a href={this.props.privacy_policy} className="link" target="_blank" rel="noopener noreferrer">Aviso Legal</a>.
          </Input>
        </div>
      </section>
    );
  }
}

export default PaymentMethods;
